export default __webpack_public_path__ + "static/media/code.be3da1ea.jpg";